import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import contactPortalService from '../services/contactPortal';
import './ContactPortal.scss';

const ContactActivate = () => {
  const [searchParams] = useSearchParams();
  const uid = useMemo(() => searchParams.get('uid') || '', [searchParams]);
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [form, setForm] = useState({ password: '', passwordConfirm: '' });
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [generalError, setGeneralError] = useState('');
  const [success, setSuccess] = useState('');

  const onChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (fieldErrors[field]) {
      setFieldErrors((prev) => ({ ...prev, [field]: '' }));
    }
    if (generalError) setGeneralError('');
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setFieldErrors({});
    setGeneralError('');
    setSuccess('');

    if (!uid || !token) {
      setGeneralError('Enlace de activacion invalido.');
      return;
    }

    setLoading(true);
    try {
      await contactPortalService.activateAccount(
        uid,
        token,
        form.password,
        form.passwordConfirm
      );
      setSuccess('Tu cuenta fue activada. Ya podes iniciar sesion.');
      setForm({ password: '', passwordConfirm: '' });
    } catch (err) {
      const detail = err.response?.data;
      if (detail && typeof detail === 'object') {
        const parsed = {};
        Object.entries(detail).forEach(([key, value]) => {
          parsed[key] = Array.isArray(value) ? value[0] : String(value);
        });
        setFieldErrors(parsed);
        if (parsed.detail) setGeneralError(parsed.detail);
      } else {
        setGeneralError('No se pudo activar la cuenta.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-portal-auth-page">
      <div className="auth-card">
        <h1>Activacion de Cuenta</h1>
        <p>Defini tu contrasena para finalizar la activacion.</p>

        {!success ? (
          <>
            <form onSubmit={onSubmit}>
              <label htmlFor="password">Contrasena</label>
              {fieldErrors.password && <div className="field-error">{fieldErrors.password}</div>}
              <input
                id="password"
                type="password"
                value={form.password}
                onChange={(e) => onChange('password', e.target.value)}
                minLength={8}
                required
              />

              <label htmlFor="passwordConfirm">Confirmar contrasena</label>
              {fieldErrors.password_confirm && <div className="field-error">{fieldErrors.password_confirm}</div>}
              <input
                id="passwordConfirm"
                type="password"
                value={form.passwordConfirm}
                onChange={(e) => onChange('passwordConfirm', e.target.value)}
                minLength={8}
                required
              />

              {generalError && <div className="error-message">{generalError}</div>}

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Activando...' : 'Activar cuenta'}
              </button>
            </form>

            <p className="auth-footer">
              <Link to="/contactos/login">Ir a Login</Link>
            </p>
          </>
        ) : (
          <>
            <div className="success-message">{success}</div>
            <p className="auth-footer">
              <Link to="/contactos/login">Ir a Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactActivate;
